import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'vw-leaf-off-icon',
    imports: [],
    styles: [`:host { display: block; }`],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4.2 4.2A7 7 0 0 0 11 20c2.3 0 4.4-1.1 5.8-2.8"/><path d="M19 2c1 2 2 4.2 2 8 0 1.6-.4 3.1-1.1 4.4"/><path d="M9.8 6.1c2.7-.5 4.4-.9 5.7-1.6"/><path d="M2 21c0-3 1.9-5.4 5.1-6"/><path d="m2 2 20 20"/></svg>`
})
export class LeafOffIconComponent {}
